/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Ticker_Round_PrefixInputs */

const bn_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রাউন্ড`)
};

const de_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RUNDEN`)
};

const el_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΓΥΡΩ`)
};

const en_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROUND`)
};

const es_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDONDO`)
};

const fr_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MANCHE`)
};

const hi_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोल`)
};

const hu_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KEREK`)
};

const id_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BULAT`)
};

const it_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GIRARE`)
};

const ja_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラウンド`)
};

const ko_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둥근`)
};

const nl_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RONDE`)
};

const pl_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OKRĄGŁY`)
};

const pt_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDONDO`)
};

const ru_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`КРУГЛЫЙ`)
};

const sv_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RUNDA`)
};

const tr_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YUVARLAK`)
};

const uk_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`КРУГЛИЙ`)
};

const vi_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRÒN`)
};

const zh_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圆形的`)
};

const zh_hant_cipher_ticker_round_prefix = /** @type {(inputs: Cipher_Ticker_Round_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圓形的`)
};

/**
* | output |
* | --- |
* | "ROUND" |
*
* @param {Cipher_Ticker_Round_PrefixInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_ticker_round_prefix = /** @type {((inputs?: Cipher_Ticker_Round_PrefixInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Ticker_Round_PrefixInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_ticker_round_prefix(inputs)
	if (locale === "de") return de_cipher_ticker_round_prefix(inputs)
	if (locale === "el") return el_cipher_ticker_round_prefix(inputs)
	if (locale === "en") return en_cipher_ticker_round_prefix(inputs)
	if (locale === "es") return es_cipher_ticker_round_prefix(inputs)
	if (locale === "fr") return fr_cipher_ticker_round_prefix(inputs)
	if (locale === "hi") return hi_cipher_ticker_round_prefix(inputs)
	if (locale === "hu") return hu_cipher_ticker_round_prefix(inputs)
	if (locale === "id") return id_cipher_ticker_round_prefix(inputs)
	if (locale === "it") return it_cipher_ticker_round_prefix(inputs)
	if (locale === "ja") return ja_cipher_ticker_round_prefix(inputs)
	if (locale === "ko") return ko_cipher_ticker_round_prefix(inputs)
	if (locale === "nl") return nl_cipher_ticker_round_prefix(inputs)
	if (locale === "pl") return pl_cipher_ticker_round_prefix(inputs)
	if (locale === "pt") return pt_cipher_ticker_round_prefix(inputs)
	if (locale === "ru") return ru_cipher_ticker_round_prefix(inputs)
	if (locale === "sv") return sv_cipher_ticker_round_prefix(inputs)
	if (locale === "tr") return tr_cipher_ticker_round_prefix(inputs)
	if (locale === "uk") return uk_cipher_ticker_round_prefix(inputs)
	if (locale === "vi") return vi_cipher_ticker_round_prefix(inputs)
	if (locale === "zh") return zh_cipher_ticker_round_prefix(inputs)
	return zh_hant_cipher_ticker_round_prefix(inputs)
});